export class ClaimsHistory_DH{
    public ClaimYear: number;
    public Details: string;
    public Amount: number;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/ClaimsHistory_DH.ts